import React, { useEffect, useState } from 'react'
import slider1 from '../Images/Slider/Banner-1.jpg'
import slider2 from '../Images/Slider/Banner-2.jpg'
import slider3 from '../Images/Slider/Banner-3.jpg'
import slider4 from '../Images/Slider/Banner-4.jpg'
import slider5 from '../Images/Slider/Banner-5.jpg'

const slides = [
  { src: slider1, alt: 'Wise FinServ private wealth banner' },
  { src: slider2, alt: 'Personalised wealth strategy banner' },
  { src: slider3, alt: 'Exceptional client journey banner' },
  { src: slider4, alt: 'Tax-efficient investing banner' },
  { src: slider5, alt: 'Legacy planning banner' },
]

const Banner = () => {
  const [activeSlide, setActiveSlide] = useState(0)
  const [isPaused, setIsPaused] = useState(false)

  useEffect(() => {
    if (isPaused) return undefined

    const autoplay = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length)
    }, 4000)

    return () => window.clearInterval(autoplay)
  }, [isPaused])

  const showPreviousSlide = () => {
    setActiveSlide((currentSlide) => (
      currentSlide === 0 ? slides.length - 1 : currentSlide - 1
    ))
  }

  const showNextSlide = () => {
    setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length)
  }

  return (
    <section
      className="home-banner"
      aria-label="Wise FinServ highlights"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onFocus={() => setIsPaused(true)}
      onBlur={() => setIsPaused(false)}
    >
      <div
        className="home-banner-track"
        style={{ transform: `translateX(-${activeSlide * 100}%)` }}
      >
        {slides.map((slide, index) => (
          <div
            className="home-banner-slide"
            key={slide.src}
            aria-hidden={index !== activeSlide}
          >
            <img
              src={slide.src}
              alt={slide.alt}
              loading={index === 0 ? 'eager' : 'lazy'}
              fetchPriority={index === 0 ? 'high' : 'auto'}
            />
          </div>
        ))}
      </div>

      <button
        className="home-banner-arrow home-banner-arrow--previous"
        type="button"
        onClick={showPreviousSlide}
        aria-label="Show previous banner"
      >
        <span aria-hidden="true">&#10094;</span>
      </button>

      <button
        className="home-banner-arrow home-banner-arrow--next"
        type="button"
        onClick={showNextSlide}
        aria-label="Show next banner"
      >
        <span aria-hidden="true">&#10095;</span>
      </button>

      <div className="home-banner-dots" aria-label="Choose a banner">
        {slides.map((slide, index) => (
          <button
            className={`home-banner-dot${index === activeSlide ? ' is-active' : ''}`}
            type="button"
            key={slide.src}
            onClick={() => setActiveSlide(index)}
            aria-label={`Show banner ${index + 1}`}
            aria-current={index === activeSlide ? 'true' : undefined}
          />
        ))}
      </div>
    </section>
  )
}

/*
 * Previous home banner retained as a backup, as requested.
 *
 * <div className='banner'>
 *   <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel" data-interval="4000">
 *     <div className="carousel-inner">
 *       <div className="carousel-item active">
 *         <div className="nbanner-card">
 *           <div className="nbanner-image"><img src={slider1} className="d-block w-100" alt="..." /></div>
 *           <div className="banner-a-title">
 *             <div className="banner-top-title2">
 *               <h4>Recognised by India's leading financial media</h4>
 *               <img src="wise-finserv-media.png" alt="banner title" />
 *             </div>
 *             <h5>Unlocking your wealth Potential</h5>
 *           </div>
 *         </div>
 *       </div>
 *       <div className="carousel-item">
 *         <div className="nbanner-card">
 *           <div className="nbanner-image"><img src={slider2} className="d-block w-100" alt="..." /></div>
 *           <div className="banner-a-title"><h5>Our abilities, your tailored strategy</h5></div>
 *         </div>
 *       </div>
 *       <div className="carousel-item">
 *         <div className="nbanner-card">
 *           <div className="nbanner-image"><img src={slider3} className="d-block w-100" alt="..." /></div>
 *           <div className="banner-a-title"><h5>Curating an Exceptional Journey for Our Valued Clients</h5></div>
 *         </div>
 *       </div>
 *       <div className="carousel-item">
 *         <div className="nbanner-card">
 *           <div className="nbanner-image"><img src={slider4} className="d-block w-100" alt="..." /></div>
 *           <div className="banner-a-title"><h5>Empowering Tax Efficiency</h5></div>
 *         </div>
 *       </div>
 *       <div className="carousel-item">
 *         <div className="nbanner-card">
 *           <div className="nbanner-image"><img src={slider5} className="d-block w-100" alt="..." /></div>
 *           <div className="banner-a-title"><h5>Crafting Your<br /> Legacy</h5></div>
 *         </div>
 *       </div>
 *     </div>
 *     <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
 *       <span className="carousel-control-prev-icon" aria-hidden="true"></span>
 *       <span className="visually-hidden">Previous</span>
 *     </button>
 *     <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
 *       <span className="carousel-control-next-icon" aria-hidden="true"></span>
 *       <span className="visually-hidden">Next</span>
 *     </button>
 *   </div>
 *   <div className="banner-marquee-bottom">
 *     <div className="banner-marquee-card">
 *       <h6>AS FEATURED IN</h6>
 *       <a href="/about-us#our-media-presence" className="block cursor-pointer">
 *         <marquee>
 *           <span>The Economic Times</span><span>ET Wealth</span><span>Mint</span>
 *           <span>Business Standard</span><span>CNBC</span><span>NDTV Profit</span>
 *           <span>Network18</span><span>and other leading publications</span>
 *         </marquee>
 *       </a>
 *     </div>
 *   </div>
 * </div>
 */

export default Banner
